
<div
  class="cmp-login-section fit column no-wrap justify-between ws-typography"
>
  <div class="login-header row">
    <img alt="logo" v-bind="logo" />
  </div>

  <div class="section login-content row">
    <div class="col">
      <h6>{{ $t('login.existing.title') }}</h6>
      <small class="block q-mb-lg">{{ $t('login.existing.text') }}</small>
      <ws-button
        primary
        :loading="loadingRedirect"
        class="full-width"
        @click="goToLogin"
      >
        {{ $t('login.existing.btn') }}
      </ws-button>
      <ws-delimiter text="wsk.general.or" class="q-my-lg" />
      <h6 class="second-title">
        {{ $t('login.new.title') }}
      </h6>
      <small class="block q-mb-lg">{{ $t('login.new.text') }}</small>
      <ws-button
        secondary
        :loading="loadingGoNext"
        class="cy--login-section--register full-width"
        @click="goNext"
      >
        {{ $t('login.new.btn') }}
      </ws-button>
    </div>
  </div>
  <div class="login-footer">
    <hr class="ws-default" />

    <div class="row content items-center">
      <div v-if="footerImage && footerImage.src" class="col-auto q-pr-xl gt-sm">
        <img alt="" v-bind="footerImage" />
      </div>
      <div class="col footer-content">
        <h6 class="ws-typo-button">
          {{ $t('login.footer.title') }}
        </h6>

        <small>
          {{ $t('login.footer.text1') }}
          <a class="ws-link" :href="footerTextUrl" target="_blank">{{
            $t('login.footer.link')
          }}</a>
          {{ $t('login.footer.text2') }}
        </small>
      </div>
    </div>
  </div>
</div>
